import { getCenteredPopupFeatures, HostAuthDetails, CheckoutSdkFrameEventType } from '@mangopay/checkout-sdk-core';
import { createPopupOverlayElement, createCloseElement, createPopupModalElement, createInfoElement } from '../utils';
import { AppEventsDispatcher } from '../proxy';

export class RedirectFlowService {
  private dispatchSdkEventOutside: AppEventsDispatcher['dispatchSdkEventOutside'];

  constructor(dispatchMessage: AppEventsDispatcher['dispatchSdkEventOutside']) {
    this.dispatchSdkEventOutside = dispatchMessage;
  }

  private childWindow: Window | null = null;

  public onOpenHostAuthPopupWindow({ url, overlay }: HostAuthDetails, unsubscribeCallbacks: (() => void)[]): void {
    if (this.childWindow) {
      this.childWindow?.close();
    }
    const features = getCenteredPopupFeatures(500, 620);
    this.childWindow = window.open(url, 'mgp-sdk-popup', features);
    if (overlay) {
      this.showPopupWindowOverlay(unsubscribeCallbacks);
    }
  }

  public hidePopupWindowOverlay() {
    this.childWindow?.close();
    const overlayElement = document.querySelector('#mgp-sdk-popup-overlay');
    overlayElement?.removeEventListener('click', this.onPopupWindowOverlayClick.bind(this));
    overlayElement?.removeEventListener('click', this.onWindowOverlayCloseClick.bind(this));
    overlayElement?.parentNode?.removeChild(overlayElement);
  }

  public onOpenHostAuthPopupModal(
    { url }: HostAuthDetails,
    unsubscribeCallbacks: (() => void)[],
    setLoading?: (loading: boolean) => void
  ) {
    const modalElement = createPopupModalElement(url, '3D Secure authentication');
    const closeElement = createCloseElement();
    closeElement.addEventListener('click', this.onModalOverlayCloseClick.bind(this, setLoading));
    unsubscribeCallbacks.push(() => {
      closeElement?.removeEventListener('click', this.onModalOverlayCloseClick.bind(this, setLoading));
      this.hidePopupModalOverlay(setLoading);
    });
    const overlayElement = createPopupOverlayElement();
    const bodyElement = document.querySelector('body');
    modalElement?.appendChild(closeElement);
    overlayElement?.appendChild(modalElement);
    bodyElement?.appendChild(overlayElement);
  }

  public hidePopupModalOverlay(setLoading?: (loading: boolean) => void) {
    const overlayElement = document.querySelector('#mgp-sdk-popup-overlay');
    overlayElement?.removeEventListener('click', this.onModalOverlayCloseClick.bind(this, setLoading));
    overlayElement?.parentNode?.removeChild(overlayElement);
  }

  private onPopupWindowOverlayClick() {
    this.childWindow?.focus();
  }

  private onWindowOverlayCloseClick() {
    this.hidePopupWindowOverlay();
  }

  private onModalOverlayCloseClick(setLoading?: (loading: boolean) => void) {
    this.dispatchSdkEventOutside(CheckoutSdkFrameEventType.Cancel, undefined);
    setLoading?.(false);
    this.hidePopupModalOverlay(setLoading);
  }

  public showPopupWindowOverlay(unsubscribeCallbacks: (() => void)[]) {
    const overlayElement = createPopupOverlayElement('pointer');
    const infoElement = createInfoElement();
    overlayElement.addEventListener('click', this.onPopupWindowOverlayClick.bind(this));
    unsubscribeCallbacks.push(() =>
      overlayElement?.removeEventListener('click', this.onPopupWindowOverlayClick.bind(this))
    );
    const closeElement = createCloseElement();
    closeElement.addEventListener('click', this.onWindowOverlayCloseClick.bind(this));
    unsubscribeCallbacks.push(() =>
      overlayElement?.removeEventListener('click', this.onWindowOverlayCloseClick.bind(this))
    );
    overlayElement.appendChild(infoElement);
    overlayElement.appendChild(closeElement);
    const bodyElement = document.querySelector('body');
    bodyElement?.appendChild(overlayElement);
    this.childWindow = window.open('', 'mgp-sdk-popup');
    const timer = setInterval(() => {
      if (this.childWindow?.closed) {
        this.hidePopupWindowOverlay();
        clearInterval(timer);
      }
    }, 1000);
  }
}
